import useGoals from '@/composables/goal/goals';
import { EVENTS } from '@/lib/constants';
import { EventBus } from '@/lib/event-bus';
import { accessPolicyType } from 'shared/constants.json';
import { computed, ref } from 'vue';
import { isNullOrUndefined } from 'shared/lib/object/object';

export default function usePublishGoals(planningId) {
  const { entityList, updateMultiple } = useGoals();

  const publishLoading = ref(false);
  const publish = ({ goalIds }) => {
    publishLoading.value = true;
    const now = (new Date()).toISOString();
    const entities = goalIds.map((id) => ({ uid: id, publishedAt: now }));
    return updateMultiple(entities).then((goals) => {
      EventBus.$emit(EVENTS.PLANNING.GOALS_PUBLISHED, { goals });
      return goals;
    }).finally(() => {
      publishLoading.value = false;
    });
  };
  const initialSelectedGoalIds = computed(() => entityList.value.filter(
    (g) => !isNullOrUndefined(g.planning) && g.planning.uid === planningId
      && g.publishedAt === null
      && [accessPolicyType.write, accessPolicyType.full].includes(g.accessRight),
  ).map((g) => g.uid));

  return {
    publish,
    publishLoading,
    initialSelectedGoalIds,
  };
}
